import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("lsk_admin_token", data.token);
      nav("/admin/orders");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-cream flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-md poster-card p-8" data-testid="admin-login-form">
        <h1 className="font-heading uppercase tracking-tight text-cream text-4xl">Staff Login</h1>
        <p className="text-cream/60 mt-1">Loaded Street Kitchen control room.</p>
        <div className="mt-6 space-y-4">
          <div>
            <label className="font-heading uppercase tracking-widest text-xs text-cream/70">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full bg-transparent border-2 border-border focus:border-gold outline-none px-3 py-2 text-cream"
              data-testid="admin-email-input"
              required
            />
          </div>
          <div>
            <label className="font-heading uppercase tracking-widest text-xs text-cream/70">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full bg-transparent border-2 border-border focus:border-gold outline-none px-3 py-2 text-cream"
              data-testid="admin-password-input"
              required
            />
          </div>
          {err && <div className="text-accent text-sm" data-testid="admin-login-error">{err}</div>}
          <button type="submit" disabled={loading} className="w-full btn-poster" data-testid="admin-login-submit">
            {loading ? <Loader2 className="h-5 w-5 animate-spin mr-2" /> : null}
            Sign In
          </button>
        </div>
      </form>
    </div>
  );
}
